import Vue from "vue";
import Vuex from "vuex";

// 该指令必须在 store 创建之前执行
Vue.use(Vuex);

// Actions(行动): 处理交互行为
const actions = {
    // context: 简化版的 store；    value: 发送过来的数据
    setToken(context, value) {
        console.log("actions", context, value);
        context.commit("setToken", value);
    },
    setRole(context, value) {
        console.log("actions", context, value);
        context.commit("setRole", value);
    },
    loginOut(context) {
        context.commit("setToken", "");
        context.commit("setRole", []);
        context.commit("setIsLogin", false);
    }
};

// Mutations(变化): 修改 state 中的数据
const mutations = {
    // state: 存储的数据；    value: 发送的数据
    setToken(state, value) {
        console.log("mutations", state, value);
        state.token = value;
        state.isLogin = true;
    },
    setRole(state, value) {
        console.log("mutations", state, value);
        state.role = value;
    },
    setIsLogin(state, value) {
        console.log("mutations", state, value);
        state.isLogin = value;
    },
};

// State: 用于存储数据
const state = {
    token: "",
    role: [],
    isLogin: false
};

// 创建并导出 store
export default new Vuex.Store({
    actions,
    mutations,
    state,
});
